import script from "./ds-smile-static.vue?vue&type=script&lang=ts&setup=true"
export * from "./ds-smile-static.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__